import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import ChargeHelper from 'features/Charge/chargeHelper';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import { AppDialogHelper } from 'general/components/AppDialog';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown, { KTBSDropdownDirections } from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
    KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import EmptyView from 'general/components/Others/EmptyView';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import ToastHelper from 'general/helpers/ToastHelper';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import DropdownTableConfigColumn from 'general/components/DropdownTableConfigColumn';
import AppConstants from 'general/constants/AppConstants';
import MenuActionDropdown from 'general/components/Others/MenuActionDropdown';
import AppRoute from 'general/constants/AppRoute';
import AgencyHelper from 'features/Agency/agencyHelper';
import Utils from 'general/utils/Utils';
import useAppConfig from 'hooks/useAppConfig';
import DropdownFilterTable from 'general/components/DropdownFilterTable';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import CustomDateRangePicker, { dateFilter, getDateFilterOption } from 'general/components/Others/CustomDateRangePicker';

RemainingAgenciesView.propTypes = {};

const defaultColumnIds =['AGENCY_CODE', 'AGENCY_NAME', 'ROLE', 'AGENCY_TYPE', 'PHONE', 'EMAIL', 'TAXCODE/CCCD', 'STATUS', 'ADDRESS', 'CREATEDBY', 'DATE'];
function RemainingAgenciesView(props) {
    // ---- params ----
    const router = useRouter();
    const { t } = useTranslation();
    const { agencyId, remainingAgenciesList, remainingAgenciesTotal, onFilterChanged, filter, handleGetRemainingAgenciesList, roleOptions, hideDateFilter = false } = props;
    const app = useSelector((state) => state.app);
    const areaTree = useSelector((state) => state.app.areaTree);
    const { user } = useSelector((state) => state.auth);
    const [operatorList, setOperatorList] = useState([]);
    const [filterDropdown, setFilterDropdown] = useState(filter);
    const adminRole = user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;
    const commissionRateSale = useAppConfig()?.commissionRateSale;
    const commissionRateGroup = useAppConfig()?.commissionRateGroup;
    const commissionRateLandlord = useAppConfig()?.commissionRateLandlord;
    const operatorId = useMemo(() => {
        return app?.appConfig?.operators?.[0]?.operatorId ?? null;
    }, [app]);

    const fullColumns = useMemo(() => {
        return [
            {
                id: 'AGENCY_CODE',
                name: <span style={{ fontSize: 12, color: AppColors.gray[900] }} className="letter-spacing-unset">{t('Mã nhà đầu tư')}</span>,
                selector: (row) => row?.agencyCode ?? row.agencyId,
                minWidth: '140px',
                style: tableStyle.columns.link,
                sortable: true,
            },
            {
                id: 'AGENCY_NAME',
                name: <span style={{ fontSize: 12, color: AppColors.gray[900] }} className="letter-spacing-unset">{t('Tên nhà đầu tư')}</span>,
                selector: (row) => row.name ?? 'N/A',
                minWidth: '230px',
                style: tableStyle.columns.normal,
                sortable: true,
            },
            {
                id: 'ROLE',
                name: <span style={{ fontSize: 12, color: AppColors.gray[900] }} className="letter-spacing-unset">{t('Vai trò')}</span>,
                selector: (row) => t(`agencyRoleDropdownTitle_${row?.primaryRole}`) ?? 'N/A',
                minWidth: '230px',
                style: tableStyle.columns.normal,
                sortable: true,
            },
            {
                id: 'AGENCY_TYPE',
                name: <span style={{ fontSize: 12, color: AppColors.gray[900] }} className="letter-spacing-unset">{t('Loại nhà đầu tư')}</span>,
                selector: (row) => row.type ? t(`accountType_${row.type}`) : 'N/A',
                style: tableStyle.columns.normal,
                minWidth: '160px',
                sortable: true,
            },
            {
                id: 'PHONE',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('phone')}
                    </span>
                ),
                selector: (row) => row.phone ?? '',
                style: tableStyle.columns.normal,
                sortable: false,
                width: '140px',
            },
            {
                id: 'EMAIL',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('email')}
                    </span>
                ),
                selector: (row) => {
                    return (
                        <KTTooltip offset={[0, 0]} text={row?.email ?? ''}>
                            <span>{row?.email ?? ''}</span>
                        </KTTooltip>
                    );
                },
                style: tableStyle.columns.link,
                minWidth: '250px',
            },
            {
                id: 'TAXCODE/CCCD',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('MST/CCCD')}
                    </span>
                ),
                selector: (row) =>
                    row.type === AppConstants.accountType.individual
                        ? row.idCardNumber?.length > 0
                            ? row.idCardNumber
                            : row.taxCode?.length > 0
                                ? row.taxCode
                                : ''
                        : row.taxCode?.length > 0
                            ? row.taxCode
                            : '',
                style: tableStyle.columns.normal,
                sortable: false,
                width: '150px',
            },
            {
                id: 'STATUS',
                name: <span style={{ fontSize: 12, color: AppColors.gray[900] }} className="letter-spacing-unset">{t('status')}</span>,
                minWidth: '150px',
                selector: (row) => (
                    <KTLabel
                        text={t(`agencyStatus_${row.status}`)}
                        isInline={true}
                        size={KTLabelSize.medium}
                        additionalClassName={`label-light-${DealerHelper.getAgencyStatusColor(row.status)}`}
                    />
                ),
                sortable: false,
            },
            {
                id: 'ADDRESS',
                name: <span style={{ fontSize: 12, color: AppColors.gray[900] }} className="letter-spacing-unset">{t('Địa chỉ')}</span>,
                selector: (row) => {
                    const area = ChargeHelper.Utils.getAreaById([areaTree], row?.areaId);
                    let parentArea;
                    if (area?.typeCode === 'W') {
                        parentArea = ChargeHelper.Utils.getAreaById([areaTree], area?.parentId);
                    }
                    const addressResult = [row.address, area?.name, parentArea?.name]
                        .filter(Boolean)
                        .join(', ');
                    return (
                        <KTTooltip text={addressResult} offset={[0, 0]}>
                            <span>{addressResult?.length > 0 ? addressResult : ''}</span>
                        </KTTooltip>
                    );
                },
                style: tableStyle.columns.normal,
                minWidth: '250px',
                sortable: false,
            },
            {
                id: 'CREATEDBY',
                name: <span style={{ fontSize: 12, color: AppColors.gray[900] }} className="letter-spacing-unset">{t('Người tạo')}</span>,
                selector: (row) => (
                    <KTTooltip offset={[0, 0]} text={row?.createdBy?.fullname ?? row?.name}>
                        <span
                            className="cursor-pointer hover-opacity-60"
                            onClick={() => {
                                DealerHelper.navigateToParentAgency(row?.createdBy ?? row);
                            }}
                        >
                            {row?.createdBy?.fullname ?? row?.name}
                        </span>
                    </KTTooltip>
                ),
                style: tableStyle.columns.link,
                width: '200px',
                sortable: false,
            },
            {
                id: 'DATE',
                name: <span style={{ fontSize: 12, color: AppColors.gray[900] }} className="letter-spacing-unset">{t('Ngày tạo')}</span>,
                selector: (row) => row?.createdAt ? Utils.formatDateTimeToString(row?.createdAt, 'DD/MM/YYYY - HH:mm') : '',
                style: tableStyle.columns.normal,
                width: '180px',
                sortable: false,
            },
            {
                name: <span style={{ fontSize: 12, color: AppColors.gray[900] }} className="letter-spacing-unset">{t('actions')}</span>,
                width: '130px',
                style: {
                    position: 'sticky',
                    right: 0,
                    backgroundColor: '#fff',
                    borderLeft: '1px solid #ebedfe',
                },
                wrap: true,
                cell: (row) => (
                    <MenuActionDropdown
                        menuAction={[
                            {
                                iconElement: <i className="fa-regular fa-eye" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                text: t('Xem chi tiết'),
                                click: () => {
                                    AgencyHelper.Navigation.navigateToAgencyDetail(null, row);
                                },
                                show: true,
                            },
                            {
                                iconElement: <i className="fa-regular fa-bolt" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                text: t('Kích hoạt tài khoản'),
                                click: () => {
                                    DealerHelper.handleAcceptAgency(row, handleGetRemainingAgenciesList);
                                },
                                show: row?.status === 'REGISTERED'
                                    && (adminRole ||
                                        DealerHelper.checkHasEditPermission(
                                            row,
                                            row?.parentAgency,
                                            user?.agency
                                        )),
                            },
                            {
                                iconElement: <i className="fa-regular fa-pen-to-square" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                text: t('edit'),
                                click: () => {
                                    if (row?.primaryRole === 'GROUP') {
                                        Utils.openInNewTab(`${AppRoute.groupList}/${row?.agencyId}/edit`);
                                    } else if (row?.primaryRole === 'INVESTOR') {
                                        Utils.openInNewTab(`${AppRoute.investorList}/${row?.agencyId}/edit`);
                                    } else if (row?.primaryRole === 'LANDLORD') {
                                        Utils.openInNewTab(`${AppRoute.landlordList}/${row?.agencyId}/edit`);
                                    }
                                },
                                show: (!row?.numberOfSignedContracts
                                    && DealerHelper.checkHasEditPermission(
                                        row,
                                        row?.parentAgency,
                                        user?.agency
                                    )) || adminRole,
                            },
                            {
                                iconElement: <i className="fa-regular fa-plus-circle" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                text: t('addOrder'),
                                click: () => {
                                    if (row?.primaryRole === 'GROUP') {
                                        Utils.openInNewTab(`${AppRoute.groupList}/add-order?group=${row?.agencyId}`);
                                    } else if (row?.primaryRole === 'INVESTOR') {
                                        Utils.openInNewTab(`${AppRoute.investorList}/add-order?investor=${row?.agencyId}`);
                                    } else if (row?.primaryRole === 'LANDLORD') {
                                        Utils.openInNewTab(`${AppRoute.landlordList}/add-order?landlord=${row?.agencyId}`);
                                    }
                                },
                                show: row?.status !== 'REGISTERED'
                                    && (adminRole || DealerHelper.checkHasEditPermission(
                                        row,
                                        row?.parentAgency,
                                        user?.agency
                                    ))
                                    && user?.agency?.primaryRole === 'SALE',
                            },
                            {
                                iconElement: <i className="far fa-square" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                text: t('Ngừng hoạt động'),
                                click: () => {
                                    DealerHelper.handleStopAgency(row, handleGetRemainingAgenciesList);
                                },
                                show: row?.status === 'NORMAL'
                                    && (adminRole || DealerHelper.checkHasEditPermission(
                                        row,
                                        row?.parentAgency,
                                        user?.agency
                                    )),
                            },
                            {
                                iconElement: <i className="far fa-play" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                text: t('Khôi phục hoạt động'),
                                click: () => {
                                    DealerHelper.handleActiveAgency(row, handleGetRemainingAgenciesList);
                                },
                                show: row?.status === 'SUSPENDED'
                                    && (adminRole || DealerHelper.checkHasEditPermission(
                                        row,
                                        row?.parentAgency,
                                        user?.agency
                                    )),
                            },
                            {
                                iconElement: (
                                    <i
                                        className="fa-regular fa-file-contract"
                                        style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                    ></i>
                                ),
                                text: 'Tạo hợp đồng CTV',
                                click: () => {
                                    // AgencyHelper.UI.showDialogConfirmCreateContractWithSale(row, () => {});
                                    AgencyHelper.UI.showDialogConfirmCreateContractWithAgency(
                                        row,
                                        () => { },
                                        undefined,
                                        async () => {
                                            const hasSaleCommission =
                                                row && row.commissions
                                                    ? await row.commissions.some(
                                                        (commission) => commission?.role === 'SALE'
                                                    )
                                                    : false;

                                            if (!hasSaleCommission) {
                                                await handleCreateSaleCommission(row);
                                            }
                                        }
                                    );
                                },
                                show:
                                    row?.status !== 'REGISTERED'
                                    && adminRole
                                    && row?.primaryRole !== 'LANDLORD',
                            },
                            {
                                iconElement: <i className={`fa-regular fa-lock`} style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                text: t('Đặt lại mật khẩu'),
                                click: () => {
                                    DealerHelper.showDialogChangePassword(row, handleGetRemainingAgenciesList)
                                },
                                show: adminRole,
                            },
                            {
                                iconElement: <i className={`fa-regular fa-trash-can`} style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                text: t(`Xóa ${row?.primaryRole === 'LANDLORD' ? 'chủ mặt bằng' : 'nhà đầu tư'}`),
                                click: () => {
                                    DealerHelper.handleDeleteAgency(row, handleGetRemainingAgenciesList);
                                },
                                show: !row?.numberOfSignedContracts
                                    && (adminRole || DealerHelper.checkHasEditPermission(
                                        row,
                                        row?.parentAgency,
                                        user?.agency
                                    )),
                            },
                        ]}
                    />
                ),
                sortable: false,
            },
        ];
    }, [t, operatorList, areaTree]);

    const prefKey = useMemo(() => {
        const userId = user.userId;
        const pathName = `${router.pathname}${router.location.hash}`;
        const key = `${userId}_${pathName}`;
        return key;
    }, [user, router]);
    const [fullColumnIds, setFullColumnIds] = useState(fullColumns?.map((row) => row?.id).filter(Boolean));
    const {
        columnIds,
        columns,
        onChangeCheckboxValue,
        resetDefaultTableColumn,
        saveChanges,
        onSelectAll,
        onUnSelectAll,
        fullColumnsIdSorted
    } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);

    // ---- methods ----

    const classifyOperators = (operators) => {
        setOperatorList(
            operators?.map((operator) => ({ operatorId: operator.operatorId, name: operator.name }))
        );
    };

    useEffect(() => {
        if (app.appConfig) {
            classifyOperators(app.appConfig.operators ?? []);
        }
    }, [app.appConfig]);

    useEffect(() => {
        setFilterDropdown(filter);
    }, [filter]);

    const handleFilterChanged = (filter) => {
        if (onFilterChanged) {
            onFilterChanged(filter);
        }
    };

    const updateFilter = (key, value) => {
        const newFilter = { ...filterDropdown, [key]: value, page: 0 };
        setFilterDropdown(newFilter);
        handleFilterChanged(newFilter);
    };

    const handleCreateSaleCommission = async (row) => {
        await DealerHelper.callApiCreateAgencyCommission(
            Utils.transformEmptyStrings({
                operatorId: operatorId,
                agencyId: row?.agencyId,
                role: 'SALE',
                energyCommissionMode: AppConstants.energyCommissionMode.fixedPerKwh,
                energyCommissionValue: 0,
                energyCommissionDuration: null,
                serviceCommission: 0,
                saleCommission: [
                    {
                        revenue: 0,
                        discount: Number(commissionRateSale),
                    },
                ],
                packageCommission: [
                    {
                        revenue: 0,
                        discount: Number(commissionRateGroup),
                    },
                ],
                landlordCommission: JSON.parse(commissionRateLandlord),
            })
        );
        handleGetRemainingAgenciesList();
    };

    const agencyRoleOptionList = roleOptions ?? [
        {
            name: 'Tất cả',
            value: 'INVESTOR, GROUP, LANDLORD, COINVESTOR'
        },
        ...DealerHelper.filterAgencyRoleOptions()
    ];

    const renderFilterComponentList = ({ isInDropdown = false }) => (
        <div className={`${isInDropdown ? 'row m-0' : 'w-100 d-flex flex-row flex-wrap'}`}>
            <KTDropdownFilter
                label={t('Vai trò')}
                filterKey="role"
                options={agencyRoleOptionList}
                selectedValue={!isInDropdown ? filter.role : filterDropdown.role}
                isInDropdown={isInDropdown}
                additionalClassName={`${isInDropdown ? 'pr-2 pb-3 pl-0' : 'pl-0 pr-4'}`}
                handleChange={(value) => {
                    if (isInDropdown) {
                        setFilterDropdown({ ...filterDropdown, role: value });
                    } else {
                        updateFilter('role', value);
                    }
                }}
                direction={KTBSDropdownDirections.up}
            />

            <KTDropdownFilter
                label={t('Loại nhà đầu tư')}
                filterKey="type"
                options={DealerHelper.filterAgencyTypeOptions()}
                selectedValue={!isInDropdown ? filter.type : filterDropdown.type}
                isInDropdown={isInDropdown}
                additionalClassName={`${isInDropdown ? 'pl-2 pb-3 pr-0' : 'pl-0 pr-4'}`}
                handleChange={(value) => {
                    if (isInDropdown) {
                        setFilterDropdown({ ...filterDropdown, type: value });
                    } else {
                        updateFilter('type', value);
                    }
                }}
                direction={KTBSDropdownDirections.up}
            />

            <KTDropdownFilter
                label={t('Trạng thái')}
                filterKey="status"
                options={DealerHelper.filterStatusOptions()}
                selectedValue={!isInDropdown ? filter.status : filterDropdown.status}
                isInDropdown={isInDropdown}
                additionalClassName={`${isInDropdown ? 'pr-2 pb-3 pl-0' : 'pl-0 pr-4'}`}
                handleChange={(value) => {
                    if (isInDropdown) {
                        setFilterDropdown({ ...filterDropdown, status: value });
                    } else {
                        updateFilter('status', value);
                    }
                }}
                direction={KTBSDropdownDirections.up}
            />

            {isInDropdown && (
                <>
                    <KTDropdownFilter
                        label={t('Người tạo')}
                        filterKey="createdBy"
                        options={DealerHelper.filterCreatedByOptions()}
                        selectedValue={filterDropdown.createdBy}
                        isInDropdown={isInDropdown}
                        additionalClassName="pl-2 pb-3 pr-0"
                        handleChange={(value) => {
                            setFilterDropdown({ ...filterDropdown, createdBy: value });
                        }}
                        direction={KTBSDropdownDirections.up}
                    />

                    {!hideDateFilter && (
                        <div
                            className="col-12 px-0 pt-3 mt-1"
                            style={{ borderTop: `1px solid ${AppColors.gray[200]}` }}
                        >
                            <label
                                htmlFor="filterByDate"
                                className="mb-2 font-weight-boldest d-block"
                                style={{ color: AppColors.gray[800] }}
                            >
                                {t('Ngày tạo')}
                            </label>
                            <CustomDateRangePicker
                                inlineMode={true}
                                toggleElementBorderRadius={5}
                                initialValue={
                                    filterDropdown.selectedValue?.length > 0
                                        ? filterDropdown.selectedValue
                                        : dateFilter.tatCaThoiGian
                                }
                                onPressSave={(selectedValue, startDate, endDate) => {
                                    setFilterDropdown({
                                        ...filterDropdown,
                                        from: startDate,
                                        to: endDate,
                                        selectedValue: selectedValue,
                                    });
                                }}
                                filterComponent={filterDropdown}
                                direction={KTBSDropdownDirections.up}
                            />
                        </div>
                    )}
                </>
            )}
        </div>
    );

    return (
        <div>
            {/* header */}
            <div className="w-100 d-flex align-items-end flex-wrap">
                <div className="col-lg-3 pl-0 py-2 pr-0 pr-xl-4 pr-lg-4">
                    <label htmlFor="search-bar" style={{ color: AppColors.gray[800] }} className="mb-0 mr-2 font-weight-boldest">
                        {t('search')}
                    </label>
                    <KTFormSearch
                        name="search-bar"
                        placeholder={t('Theo mã nhà đầu tư, tên, số điện thoại, email, MST/CCCD...')}
                        value={filter.q}
                        onSubmit={(text) => {
                            handleFilterChanged({
                                q: text,
                                page: 0,
                            });
                            setFilterDropdown({ ...filter, q: text, page: 0 });
                        }}
                    />
                </div>
                <div className="col-xl-7 col-lg-9 px-0">
                    {renderFilterComponentList({ isInDropdown: false })}
                </div>

                <div className="py-2">
                    <DropdownFilterTable
                        filterComponent={[
                            <div className="mb-3">
                                <KTFormSearch
                                    name="search-bar"
                                    placeholder={t('Theo mã nhà đầu tư, tên, số điện thoại, email, MST/CCCD...')}
                                    value={filterDropdown.q}
                                    onSubmit={(text) => {
                                        setFilterDropdown({ ...filterDropdown, q: text });
                                    }}
                                />
                            </div>,
                            renderFilterComponentList({ isInDropdown: true }),
                        ]}
                        resetDefaultTable={() => {
                            const updateFilterDropdown = {
                                ...filterDropdown,
                                q: '',
                                role: filter.role,
                                type: '',
                                status: '',
                                createdBy: '',
                                from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
                                to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
                                selectedValue: dateFilter.tatCaThoiGian,
                                page: 0,
                            };
                            setFilterDropdown(updateFilterDropdown);
                            handleFilterChanged(updateFilterDropdown);
                        }}
                        saveFilter={() => {
                            handleFilterChanged({ ...filterDropdown, page: 0 });
                        }}
                        isDefaultFilter={Utils.checkDefaultFilter(
                            ['role', 'page', 'limit', 'from', 'to', 'selectedValue', 'parentAgencyId'],
                            filter
                        )}
                        direction={KTBSDropdownDirections.up}
                    />
                </div>
            </div>

            {/* Body */}
            <div className="mt-4">
                <KTTable
                    columns={columns}
                    items={remainingAgenciesList}
                    selectableRows={false}
                    striped={false}
                    compactGrid={false}
                    onClickedRow={() => { }}
                    onSelectedRowsChanged={(rows) => { }}
                    onDoubleClickedRow={(rows) => { }}
                    noDataComponent={
                        <EmptyView
                            icon={imgEmptyNoData}
                            title="Không có dữ liệu để hiển thị"
                            text={
                                <div className="text-center">
                                    <span>
                                        Hiện không có dữ liệu để hiển thị. Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.
                                    </span>
                                </div>
                            }
                        />
                    }
                />
            </div>

            {/* Phân trang */}
            {!_.isEmpty(remainingAgenciesList) && (
                <div className="mt-4">
                    <KTPagination
                        currentPage={filter.page + 1}
                        rowCount={remainingAgenciesTotal}
                        rowsPerPage={filter.limit}
                        currentItemInPageCount={remainingAgenciesList.length}
                        onChangePage={(newPage) => {
                            const iNewPage = parseInt(newPage);
                            handleFilterChanged({
                                page: iNewPage - 1,
                            });
                        }}
                        onChangeRowsPerPage={(newRowsPerPage) => {
                            const iNewRowsPerPage = parseInt(newRowsPerPage);
                            handleFilterChanged({
                                limit: iNewRowsPerPage,
                                page: 0,
                            });
                        }}
                        loading={false}
                        color={KTPaginationColor.success}
                        appendText="đối tác"
                    />
                </div>
            )}
        </div>
    );
}

export default RemainingAgenciesView;
